import { useDeleteDataSource } from 'api/services/dataSourceService';
import { GenericDeleteModal } from 'components/ui/GenericDeleteModal';
import { useFloatNotification } from 'contexts/FloatNotificationContext';
import { useUI } from 'contexts/UiContext';
import { useTranslation } from 'react-i18next';
import { ErrorType } from 'types/genericTypes';

interface DeleteDataSourceModalProps {
  open: boolean;
  onCancel: () => void;
  dataSourceId?: string;
  name?: string;
}

export const DeleteDataSourceModal = ({
  open,
  onCancel,
  dataSourceId,
  name,
}: DeleteDataSourceModalProps) => {
  const { t } = useTranslation();
  const { selectedCompany } = useUI();
  const { openNotification } = useFloatNotification();
  const {
    mutateAsync: deleteDataSource,
    isPending: isPendingDeleteDataSource,
  } = useDeleteDataSource();

  const handleConfirm = async () => {
    try {
      await deleteDataSource({
        companyId: selectedCompany || '',
        dataSourceId: dataSourceId || '',
      });
      openNotification(
        t('success'),
        t('data-sources.delete-modal.on-success'),
        'success'
      );
      onCancel();
    } catch (error) {
      const apiError = error as ErrorType;
      if (apiError.body?.errorCode) {
        openNotification(t('error'), t(apiError.body.errorCode), 'error');
      } else {
        openNotification(
          t('error'),
          t('data-sources.delete-modal.on-error'),
          'error'
        );
      }
    }
  };

  return (
    <GenericDeleteModal
      open={open}
      onCancel={onCancel}
      onOk={handleConfirm}
      confirmLoading={isPendingDeleteDataSource}
      bodyText={t('data-sources.delete-modal.delete-text', {
        dataSourceName: name,
      })}
    />
  );
};
